import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/utility-provider/`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAccountsListFilters: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/utility-provider/list-filters`);
  },
  /**
   * Get the all data for export the Accounts list without pagination
   * @param query
   * @returns
   */
  exportData: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.accountApiUrl}api/super-admin/v1/utility-provider/export-utility`,
      { ...parameters },
    );
  },
  /**
   * Fetch single Accounts list with pagination
   */
  fetchOneAccounts: (query: string): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/utility-provider/${query}`, {});
  },
  /**
   * create the Utility provider account
   */
  createUtilityAccounts: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.accountApiUrl}api/super-admin/v1/utility-provider/`, parameters);
  },
  /**
   * Edit the Utility provider account
   * @param id
   * @param data
   * @returns
   */
  editUtilityAccounts: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.accountApiUrl}api/super-admin/v1/utility-provider/${id}`, {
      ...parameters,
    });
  },
  /**
   * Approved the account function
   * @param id
   * @param data
   * @returns
   */
  approvedAccounts: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.accountApiUrl}api/super-admin/v1/utility-provider/verify-account/${id}`,
      { ...parameters },
    );
  },
  /**
   * Delete the account api call function
   * @param data
   * @returns
   */
  deleteAccount: (id: String): Promise<any> => {
    return deleteRequest(`${config.accountApiUrl}api/super-admin/v1/utility-provider/${id}`);
  },
};
